module.exports = __webpack_public_path__ + "media/images/front/about/icon03-2b43d361c4acc1cfbd02cf38c516aa18.png";